import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import DoorImage from 'shared/images/door.webp'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

const KyrgyzstanCancelBookingSuccessPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // TODO: Получать данные из API и определять вариант на основе условий
  const isLessThan24Hours = false

  const handleMyOrders = () => {
    navigate(RoutingPaths.myOrders.path(), {
      replace: true,
    })
  }

  const handleFindAccommodation = () => {
    navigate(RoutingPaths.kyrgyzstan.path(), {
      replace: true,
    })
  }

  return (
    <div className={clsx('container', 'safe-area-top-padding', s.container)}>
      <div className={s.imageWrapper}>
        <img
          src={DoorImage}
          alt="door_image"
          className={s.image}
        />
      </div>

      <div className={s.text}>
        <h3 className={clsx('bold-24', s.title)}>
          {t('kyrgyzstan_block.cancel_booking_success.title')}
        </h3>
        <p className={clsx('medium-14', s.description)}>
          {isLessThan24Hours
            ? t('kyrgyzstan_block.cancel_booking_success.description.refund')
            : t('kyrgyzstan_block.cancel_booking_success.description.search')}
        </p>
      </div>

      <Button
        className={s.button}
        variant="grey"
        onClick={isLessThan24Hours ? handleMyOrders : handleFindAccommodation}
      >
        <span className={clsx('bold-16', s.buttonText)}>
          {isLessThan24Hours
            ? t('kyrgyzstan_block.cancel_booking_success.button.my_orders')
            : t(
                'kyrgyzstan_block.cancel_booking_success.button.find_accommodation',
              )}
        </span>
      </Button>
    </div>
  )
}

export default KyrgyzstanCancelBookingSuccessPage
